/* ==========================================================================
   LOYAL · ADD TO BAG WITHOUT LEAVING THE PAGE
   and the band's own piping confirming it.

   THE DEFECT THIS FIXES IS A CONVERSION DEFECT, NOT A MOTION ONE, and it was
   found while wiring the motion. Dawn's <product-form> only fetches when a
   <cart-notification> or <cart-drawer> exists in the DOM. This theme replaced
   Dawn's header and never shipped either, so the element silently fell back to
   a NATIVE FORM POST: every add navigated to /cart.

   Measured, not assumed. Clicking add to bag moved location.href from
   /products/funk-black-boxer-brief to /cart and a marker set on window before
   the click was gone afterwards, which is a full document load.

   WHY THAT MATTERS MORE THAN ANYTHING ELSE ON THIS PAGE. The store's job this
   week is sell-through across NINE styles. Ripping the shopper to the cart on
   every add means a second pair costs a back navigation, a scroll back to
   where they were, and a re-decision. Multi-pair is the entire margin story,
   and the interface was charging a page load for it.

   THE MOTION AND THE FIX ARE THE SAME OBJECT. The band's red piping, the
   thinnest element on the site and the thing every hairline is cut from,
   travels from the button that was pressed to the bag in the nav. That is the
   anchor performing the confirmation rather than a toast reporting it. It
   fires ONLY after the server confirms, because a confirmation that can lie is
   worse than none at the one moment money is involved.

   PROGRESSIVE ENHANCEMENT SURVIVES. The form still posts to /cart/add on its
   own if this script never runs. Nothing here is required to buy.
   ========================================================================== */
(function () {
  'use strict';

  var TRAVEL_MS = 520;
  var EASE = 'cubic-bezier(0.16, 1, 0.3, 1)';

  function reduced() {
    return window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function fly(from, to) {
    if (reduced() || !from || !to || !from.animate) return;
    var a = from.getBoundingClientRect();
    var b = to.getBoundingClientRect();
    if (a.bottom < 0 || a.top > window.innerHeight) return;

    var w = Math.max(48, a.width);
    var rule = document.createElement('span');
    rule.className = 'loyal-confirm__rule';
    rule.setAttribute('aria-hidden', 'true');
    rule.style.left = a.left + 'px';
    rule.style.top = (a.top + a.height / 2) + 'px';
    rule.style.width = w + 'px';
    document.body.appendChild(rule);

    var dx = (b.left + b.width / 2) - (a.left + w / 2);
    var dy = (b.top + b.height / 2) - (a.top + a.height / 2);

    rule.animate([
      { transform: 'translate3d(0,0,0) scaleX(1)', opacity: 1 },
      { transform: 'translate3d(' + (dx * 0.55) + 'px,' + (dy * 0.34) + 'px,0) scaleX(0.42)', opacity: 1, offset: 0.55 },
      { transform: 'translate3d(' + dx + 'px,' + dy + 'px,0) scaleX(0.06)', opacity: 0 }
    ], { duration: TRAVEL_MS, easing: EASE, fill: 'forwards' })
      .addEventListener('finish', function () {
        if (rule.parentNode) rule.parentNode.removeChild(rule);
        to.classList.add('is-caught');
        setTimeout(function () { to.classList.remove('is-caught'); }, 340);
      });
  }

  function setCount(n) {
    var bags = document.querySelectorAll('[data-loyal-bag]');
    for (var i = 0; i < bags.length; i++) {
      var el = bags[i];
      el.innerHTML = el.innerHTML.replace(/(\d+)(?!.*\d)/, String(n));
    }
  }

  function say(form, msg, isError) {
    /* LOOK OUTSIDE THE FORM. The error wrapper is a SIBLING of <form>, inside
       <product-form>, so form.querySelector never found it and every message
       this file has ever tried to show has gone nowhere: the size gate blocked
       the add correctly and then said nothing, which is worse than not
       blocking it. Found by pressing the button and asking the DOM whether the
       wrapper was still hidden. */
    var scope = form.closest('product-form') || form.parentElement || form;
    var box = scope.querySelector('.product-form__error-message-wrapper');
    var span = scope.querySelector('.product-form__error-message');
    if (!box || !span) return;
    if (!msg) { box.hidden = true; return; }
    span.textContent = msg;
    box.hidden = false;
    box.setAttribute('data-tone', isError ? 'error' : 'ok');
  }

  function wire(form) {
    if (form.dataset.loyalAdd) return;
    form.dataset.loyalAdd = '1';

    /* CAPTURE PHASE, AND stopImmediatePropagation. Dawn's ProductForm binds its
       own submit listener in the bubble phase. Without both of these it runs
       too, and the page posts anyway underneath a successful fetch: two adds,
       one visible. */
    /* GATE ON A CHOSEN SIZE. Nothing is pre-checked any more, because
       pre-checking S on a final-sale product ships wrong sizes. That makes it
       this handler's job to refuse an add with no size and to say which
       question is unanswered, rather than silently adding whatever Shopify
       considers first. */
    function sizeMessage(f) {
      var radios = f.querySelectorAll('.loyal-pdp__sizeinput');
      var labels = [];
      for (var i = 0; i < radios.length; i++) {
        var l = f.querySelector('label[for="' + radios[i].id + '"]');
        var txt = l ? (l.textContent || '').trim() : (radios[i].value || '').trim();
        if (txt) labels.push(txt);
      }
      if (!labels.length) return 'Choose an option first.';
      if (labels.length === 1) return 'Tap ' + labels[0] + ' first.';
      // ES5 on purpose: the rest of this file is ES5 and a single optional chain
      // would be the only modern syntax in it.
      var root = f.closest ? f.closest('.loyal-pdp') : null;
      var hasChart = !!(root && root.querySelector('.loyal-pdp__sizechart'));
      return 'Choose a size first. Sizes run ' + labels[0] + ' to ' + labels[labels.length - 1] +
             (hasChart ? ', and the chart is just below.' : '.');
    }

    function sizeChosen(f) {
      var radios = f.querySelectorAll('.loyal-pdp__sizeinput');
      if (!radios.length) return true;                 // no size options at all
      for (var i = 0; i < radios.length; i++) if (radios[i].checked) return true;
      return false;
    }

    form.addEventListener('submit', function (e) {
      if (!window.fetch || !window.FormData) return;   // let the native post win

      if (!sizeChosen(form)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        /* THE MESSAGE IS BUILT FROM THIS PRODUCT'S OWN OPTIONS.
           It used to be the hardcoded sentence "Choose a size first. Sizes run S
           to 2XL, and the chart is just below." Socks have one value called One
           Size and no size chart, so on five product pages the error named a
           range the product does not come in and pointed at a chart that is not
           there. An error that describes a different product is worse than no
           error: it sends the shopper looking for something that does not exist. */
        say(form, sizeMessage(form), true);
        var group = form.querySelector('.loyal-pdp__sizes');
        if (group) {
          group.scrollIntoView({ block: 'center', behavior: 'smooth' });
          var first = form.querySelector('.loyal-pdp__sizeinput');
          if (first) first.focus();
        }
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();

      var btn = form.querySelector('[type="submit"]:not([disabled])')
        || form.querySelector('[data-loyal-submit]');
      var pressed = document.activeElement && document.activeElement.form === form
        ? document.activeElement : btn;

      var label = btn ? btn.querySelector('[data-loyal-submit-text]') : null;
      var was = label ? label.textContent : null;

      /* PAINT THE BUSY STATE, DO NOT ONLY ANNOUNCE IT. The review sampled this
         at 60, 160, 320 and 600ms and found nothing changed on screen for
         roughly 900ms after the press: same label, same fill, no spinner, and
         the button never disabled, so a second press queued a second add.
         aria-busy existed with no visual counterpart, which helps a screen
         reader and nobody else. */
      if (btn) {
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;
        btn.classList.add('is-adding');
      }
      if (label) label.textContent = 'Adding';
      say(form, '');

      var body = new FormData(form);
      body.append('sections_url', window.location.pathname);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) {
            // Shopify puts the human-readable reason in `description`. Naming
            // the problem is the whole job of an error: "sold out in L" is
            // actionable, "something went wrong" is not.
            say(form, res.j.description || res.j.message || 'That size is not available.', true);
            return;
          }
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              setCount(cart.item_count);
              var bag = document.querySelector('[data-loyal-bag]');
              fly(pressed || btn, bag);
              if (label) label.textContent = 'Added';
              if (btn) btn.classList.add('is-added');
              /* The confirmed state holds for four seconds, not 1.6. A shopper
                 who looked away for a moment should still find the answer when
                 they look back. */
              setTimeout(function () {
                if (label && was !== null) label.textContent = was;
                if (btn) btn.classList.remove('is-added');
              }, 4000);
            });
        })
        .catch(function () {
          say(form, 'Could not reach the bag. Check your connection and try again.', true);
        })
        .then(function () {
          if (btn) {
            btn.removeAttribute('aria-busy');
            btn.disabled = false;
            btn.classList.remove('is-adding');
          }
        });
    }, true);
  }

  function boot() {
    var forms = document.querySelectorAll('form[action$="/cart/add"], form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) wire(forms[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
